import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.5223 3.5223Q4.0045 3.0402 4.7277 3h9.4419q.7233.0402 1.2054.5223.4821.4822.4821 1.2054v1.7277h-1.6875V4.7277h-9.442v9.4419h1.7278v1.6875H4.7277q-.7233 0-1.2054-.4821T3 14.1696v-9.442q.0402-.723.5223-1.2053m5.1429 5.1429q.4821-.4823 1.2053-.5223h1.7277v1.7276H9.8705v1.7277H8.143V9.8705q.0401-.7232.5223-1.2053m4.6205-.5223v1.7276h.8839v.8438h1.6875V8.1429zm4.2991 1.7276V8.143h1.7277q.7232.0401 1.2054.5223.482.482.482 1.2052v9.442q0 .7232-.4821 1.2054Q20.0357 21 19.3125 21h-9.442q-.7232 0-1.2053-.4821-.4823-.4822-.5223-1.2054v-1.7277h1.7276v1.7277h9.442v-9.442zm-3.4152 2.5715v1.7276H12.442v1.6875h1.7276q.7233 0 1.2054-.4821t.4821-1.2054V12.442zM8.143 15.8571v-2.5714h1.7276v.8839h.8438v1.6875z"
    clipRule="evenodd"
  />,
  'Composite',
);
